// Copyright (c) Docugami, Inc. All rights reserved.**/

import { machineGreen } from "components/shell/presentation/AppStyles";
import { useConfirmLabel } from "hooks/ConfirmLabel";
import { useAppSelector } from "hooks/redux";
import { forwardRef, Ref } from "react";
import { selectGetFeedbackStatus } from "store/frontend/frontendSlice";
import { ConfirmationButton } from "./ConfirmationButton";

interface FeedbackConfirmationButtonProps {
    label: string;
    labelId?: string;
    docsetId: string;
    documentId: string;
    spanIds?: string[];  // Set if the span ids to lock are different from the current label chunks for this document
    hidden?: boolean;
    onConfirmComplete?: () => void;
}

export const FeedbackConfirmationButton = forwardRef((props: FeedbackConfirmationButtonProps, ref?: Ref<HTMLDivElement>) => {
    const isTraining = useAppSelector(state => !!props.labelId && !!selectGetFeedbackStatus(state, props.docsetId)?.labelIds?.includes(props.labelId));

    const { isConfirmed, confirm, unconfirm } = useConfirmLabel(props.documentId, props.label);

    function getTooltip() {
        if (isTraining) {
            return 'Learning from your feedback for this item.';
        }
        else if (!isConfirmed) {
            return "Mark Complete?"
        }
        else {
            return "Complete"
        }
    }

    function onConfirmClick(ev?: any) {
        ev?.stopPropagation();

        if (isConfirmed) {
            unconfirm();
        } else {
            confirm(props.spanIds);
            props.onConfirmComplete?.();
        }
    }

    return (
        <ConfirmationButton
            ref={ref}
            isConfirmed={isConfirmed}
            onClick={onConfirmClick}
            confirmedBackgroundColor={machineGreen}
            tooltip={getTooltip()}
            hidden={props.hidden}
            pulse={isTraining} />
    )
})
